import { Link } from "react-router-dom";
import { getDocUrl } from "./docUrl";

const CrfDocLink = ({ crfExtension, externalUrl, crfName, crfId }) => {
  if (!externalUrl && crfExtension !== '.noc')
    return <>{crfName}</>;

  const fileName = externalUrl.split("/").pop();
  const ahref = getDocUrl(externalUrl);

  return (
    <>
      {" "}
      {crfExtension !== ".noc" ? (
        <a href={ahref} download={fileName} rel="noreferrer">
          {crfName}
        </a>
      ) : (
        <Link to={`/noc-report/${crfId}/${encodeURIComponent(crfName)}`} target="_blank">{crfName}</Link>
      )}
    </>
  );
};

export default CrfDocLink;
